import React from "react"
import FeaturedFaq from "./FeaturedFaq/index"
import FeaturedVideo from "./FeaturedVideo/index"
import ExperienceLayers from "./ExperienceLayers/index"
import CoursePhases from "./CoursePhases/index"
import ActivityBundles from "./ActivityBundles/index"
import FeaturedStories from "./FeaturedStories/index";
import Text from "./Text/index";
import Outcomes from "./Outcomes/index";
import Acknowledgement from "./Acknowledgment";
import Resources from "./Resources";
import Supporters from "./Supporters";

function Paragraph(props) {
  return (
    <>
    {
      props.type === "paragraph--featured_faq" &&
      <FeaturedFaq
        id={props.id}
        type={props.type}
      />
    }
    {
      props.type === "paragraph--featured_video" &&
      <FeaturedVideo
        id={props.id}
        type={props.type}
      />
    }
    {
      props.type === "paragraph--experience_layers" &&
      <ExperienceLayers
        id={props.id}
        type={props.type}
      />
    }
    {
      props.type === "paragraph--course_phases" &&
      <CoursePhases
        id={props.id}
        type={props.type}
      />
    }
    {
      props.type === "paragraph--activity_bundles" &&
      <ActivityBundles
        id={props.id}
        type={props.type}
      />
    }
    {
      props.type === "paragraph--featured_stories" &&
      <FeaturedStories
        id={props.id}
        type={props.type}
      />
    }
    {
      props.type === "paragraph--text" &&
      <Text
        id={props.id}
        type={props.type}
      />
    }
    {
      props.type === "paragraph--learning_outcomes" &&
      <Outcomes
        id={props.id}
        type={props.type}
      />
    }
    {
      props.type === "paragraph--acknowledgement" &&
      <Acknowledgement
        id={props.id}
        type={props.type}
      />
    }
    {
      props.type === "paragraph--resources" &&
      <Resources
        id={props.id}
        type={props.type}
      />
    }
    {
      props.type === "paragraph--sponsors" &&
      <Supporters
        id={props.id}
        type={props.type}
      />
    }
    </>
  )
}



export default Paragraph
